<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start">
          <div class="form-group has-search ml-3 my-3 position-relative">
            <label class="vs-input--label">START DATE</label>
            <div>
              <flat-pickr
                class="w-100"
                :config="{
                  ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i:s',
                  defaultDate: new Date().setHours(0, 0, 0),
                }"
                v-model="start_time"
                @input="SetDatetimeForStart"
              />
            </div>
          </div>
          <div class="form-group has-search ml-3 my-3 position-relative">
            <label class="vs-input--label">END DATE</label>
            <div>
              <flat-pickr
                class="w-100"
                :config="{
                ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i:s',
                  defaultDate: new Date().setHours(23, 59, 59),
                }"
                v-model="end_time"
                @input="SetDatetimeForEnd"
              />
            </div>
          </div>

          <!--          <div class="md:mb-5 ml-6">
                      <label class="vs-input&#45;&#45;label">Caller ID</label>
                        <vs-input/>
                    </div>
                    <div class="md:mb-5 ml-6">
                      <label class="vs-input&#45;&#45;label">Destination Number</label>
                        <vs-input/>
                    </div>-->
          <div class="form-group has-search ml-3 my-3 position-relative">
            <label class="vs-input--label">Bucketization</label>
            <v-select
              name="step"
              label="name"
              placeholder="Select All Day or Daily"
              v-model="step"
              :options="steps"
            />
          </div>
          <div class="form-group has-search ml-3 my-3 position-relative">
            <vs-button class="ml-auto mt-6" @click="Submit">Submit</vs-button>
          </div>
        </div>

      </div>

    </vx-card>
    <vx-card>
      <label class=" vs-input--label ml-1">Phone Numbers</label>
      <div class="form-group has-search ml-3 position-relative t-2">

        <span class="fa fa-search form-control-company-feedback"></span>
        <input
          @input="SearchPhone()"
          id="quickFilter"
          v-model="search_balance"
          class="filter_input_company form-control-company "

        >
      </div>
    </vx-card>
      <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0" >
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        :class="{'noDataTable': !list.length}"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
  // Mixins
  import TableMixin from '@/mixins/table.js'
  import DateTimeMixin from '@/mixins/datetime.js'

  // Packages
  import vSelect from 'vue-select'
  import { AgGridVue } from 'ag-grid-vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import {format} from "date-fns";

  export default {
    mixins: [TableMixin, DateTimeMixin],
    components: {
      AgGridVue,
      flatPickr,
      vSelect,

      // CellRendererLink,
      // CellRendererStatus,
      // CellRendererVerified,
      // CellRendererActions,
    },
    data() {
      return {
        start_time:  new Date().setHours(0, 0, 0),
        end_time:  new Date().setHours(23, 59, 59),
        steps:[],
        list:[],
        search_balance :'',
        stepsValue:'day',
        step: {
          name:"Daily",
          value:"day"
        },
        page :1,
        from:0,
        count: 10,
        // table header value

        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          width: 100,
          sortable: true,
          resizable: true,
          filter: true,
          flex: 1,
          minWidth: 100,
        },
        columnDefs: [
          {
            headerName: 'Data',
            field: 'start_time',
            minWidth: 260,
          },
          {
            headerName: 'Incoming SMS',
             children: [
               { headerName: 'Count', field: 'country', minWidth: 200 },


             ],
            minWidth: 120
          },
          {
            headerName: 'Outgoing SMS',
            // minWidth: 800,
            style:'margin-left:200px',
             children: [
               { headerName: 'Count', field: 'count', minWidth: 200 },
               { headerName: 'Sent', field: 'sent', minWidth: 200 },
               { headerName: 'Error', field: 'error', minWidth: 200 },
               { headerName: 'Cost', field: 'cost', minWidth: 200 },

             ],
            //   minWidth: 120
          },

        ],

        // Cell Renderer components
        components: {
          //     CellRendererActions,
          //     CellRendererStatus
        },
        //   searchProduct: ''
      }
    },
    created() {
      this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
      this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
      this.steps=[
        {
          name: 'All Day',
          value: 'all day',
        },
        {
          name: 'Daily',
          value: 'day',
        }
      ]
    },
    methods: {
      pagination(int) {
        this.from = this.per_page * (this.page === 0 ? 0 :this.page - 1)
        this.count = this.total  % 10
        this.count =this.total>this.per_page?this.per_page:this.count
        console.log(this.count,"this.count",this.from,"this.from")
        this.GetList()
      },
      // inputStepValue(value) {
      //   this.stepsValue = value.value;
      //
      // },
      SetDatetimeForStart(e) {
        this.filters.start_time =  parseInt((new Date(this.start_time).getTime()/1000))
      },
      SetDatetimeForEnd(e){
        this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
      },
      Submit()  {
        this.$vs.loading()
        this.filters.start_time = this.filters.start_time ? this.filters.start_time  : parseInt((new Date(this.start_time).getTime()/1000))
        this.filters.end_time = this.filters.end_time ?  this.filters.end_time : parseInt((new Date(this.end_time).getTime()/1000))
        this.$store.dispatch('log/GetList', {
          ...this.filters,
          count: this.count || 10,
          reporting:true,
          page: this.page || 0,
          from: this.from,
          per_page: this.per_page || 10,
          order_by: this.order_by || 'sms_time',
          order_dir: this.order_dir || 'desc',
        })
          .then(res => {
            this.list = res.data.map(this.TransformReseller)
            this.total = res.total
            this.from = res.from
          })
          .catch()
          .finally(() => {

            this.$vs.loading.close()
          })
      },
      SearchPhone(){
        this.Submit()
      },

      TransformReseller(item) {
        console.log(item)
        return {
          refreshData: this.GetList,
          ani: item.ani,
          sent: item.sent,
          start_time: format(new Date(item.sms_time * 1000), 'yyyy-dd-MM HH:mm:ss'),
          country: item.country,
          route_status: item.route_status,
          delivered: item.delivered === null ? 'No dlr' : item.delivered,
          tx_cost: item.tx_cost,
          relay_dlr_content: item.relay_dlr_content.split(" ").reverse()[0].split(':')[1]
        }
      },

    }
  }
</script>
<style>
  #select{

  }
  .filter_input_reseller{
    padding: 17px;
    padding-left: 55px;
    width: 300px;
    border: 1px solid #f5f5f5;
    font-size: 13px;
    color: gray;
    background-repeat: no-repeat;
    background-position: left center;
    outline: 0;
  }
  .has-search .form-control-reseller-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 15px;
    height: 15px;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: gray;
    margin-left: 35px;
    margin-top: 20px;
  }
  .sent-btn {
    margin-right: auto!important;
    padding-top: 10px;
  }

</style>
<style scoped>
  .filter_input_company{
    padding: 17px;
    padding-left: 55px;
    width: 220px;
    height: 41px;
    border: 1px solid #f5f5f5;
    font-size: 13px;
    color: gray;
    background-repeat: no-repeat;
    background-position: left center;
    outline: 0;
  }
  .has-search .form-control-company-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 15px;
    height: 15px;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: gray;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
  }
</style>
<style scoped lang="scss">

  .ag-theme-material /deep/ .ag-overlay-no-rows-center {
    margin-top: 45px!important;
  }
</style>
